// Local stock-photo fallback for known facility types, used only until the
// backend adds a real photo_url on GET /api/facilities. No rights-clear
// photos of USJP's own facilities are publicly available (checked the
// official site, sports.sjp.ac.lk — which has an expired SSL cert, and
// Wikimedia Commons), so these are representative stock photos sourced
// under the Pexels License (free for commercial use, no attribution
// required):
//   basketball-court.jpg  — pexels.com/photo/aerial-view-of-basketball-court-9739470/ (Kindel Media)
//   gym.jpg               — pexels.com/photo/empty-interior-of-gym-17227607/ (hi room)
//   swimming-pool.jpg     — pexels.com/photo/swimming-pool-lane-6-empty-261060/ (Pixabay, CC0)
//   tennis-court.jpg      — pexels.com/photo/tennis-court-top-view-16345586/ (Rok P)
//   volleyball-court.webp — user-supplied file, not from the Pexels set above
const FACILITY_IMAGE_RULES = [
  { test: /basketball/i, src: "/images/facilities/basketball-court.jpg" },
  { test: /volleyball/i, src: "/images/facilities/volleyball-court.webp" },
  { test: /tennis/i, src: "/images/facilities/tennis-court.jpg" },
  { test: /swim|pool/i, src: "/images/facilities/swimming-pool.jpg" },
  { test: /gym/i, src: "/images/facilities/gym.jpg" },
];

// Matches on facility_name (case-insensitive substring) — returns null for
// any name that doesn't match a known type, so callers can fall through to
// their existing icon placeholder for future/unrecognized facilities.
export function getFacilityFallbackImage(facilityName) {
  const rule = FACILITY_IMAGE_RULES.find((r) => r.test.test(String(facilityName || "")));
  return rule ? rule.src : null;
}
